import React from 'react';
import './Shimmer.css';

// Base shimmer component
export const ShimmerBlock = ({ width = '100%', height = '20px', className = '', style = {} }) => (
    <div
        className={`shimmer-block ${className}`}
        style={{ width, height, ...style }}
    />
);

// Table shimmer - for data tables
export const TableShimmer = ({ rows = 5, columns = 5 }) => (
    <div className="shimmer-table">
        {/* Table header */}
        <div className="shimmer-table-header">
            {Array.from({ length: columns }).map((_, i) => (
                <ShimmerBlock key={`header-${i}`} height="16px" />
            ))}
        </div>
        {/* Table rows */}
        {Array.from({ length: rows }).map((_, rowIndex) => (
            <div key={`row-${rowIndex}`} className="shimmer-table-row">
                {Array.from({ length: columns }).map((_, colIndex) => (
                    <ShimmerBlock key={`cell-${rowIndex}-${colIndex}`} height="14px" />
                ))}
            </div>
        ))}
    </div>
);

// Card shimmer - for card-based layouts
export const CardShimmer = ({ count = 3, columns = 3, variant = 'default' }) => (
    <div className={`shimmer-cards shimmer-cards-col-${columns}`}>
        {Array.from({ length: count }).map((_, i) => (
            <div key={`card-${i}`} className="shimmer-card">
                <div className="shimmer-card-header">
                    <ShimmerBlock width="50px" height="50px" className="shimmer-card-icon" />
                    <div className="shimmer-card-title-group">
                        <ShimmerBlock width="70%" height="18px" />
                        <ShimmerBlock width="90%" height="14px" style={{ marginTop: '8px' }} />
                    </div>
                </div>
                <div className="shimmer-card-body">
                    {variant === 'large' ? (
                        <>
                            <ShimmerBlock width="100%" height="32px" style={{ marginBottom: '12px' }} />
                            <ShimmerBlock width="100%" height="32px" style={{ marginBottom: '12px' }} />
                            <ShimmerBlock width="75%" height="32px" />
                        </>
                    ) : (
                        <>
                            <ShimmerBlock width="100%" height="12px" />
                            <ShimmerBlock width="100%" height="12px" style={{ marginTop: '8px' }} />
                            <ShimmerBlock width="60%" height="12px" style={{ marginTop: '8px' }} />
                        </>
                    )}
                </div>
            </div>
        ))}
    </div>
);

// Stats shimmer - for dashboard statistics
export const StatsShimmer = ({ count = 4 }) => (
    <div className="shimmer-stats">
        {Array.from({ length: count }).map((_, i) => (
            <div key={`stat-${i}`} className="shimmer-stat-card">
                <div className="shimmer-stat-header">
                    <ShimmerBlock width="40px" height="40px" className="shimmer-stat-icon" />
                    <ShimmerBlock width="80px" height="28px" className="shimmer-stat-value" />
                </div>
                <ShimmerBlock width="60%" height="14px" className="shimmer-stat-label" />
            </div>
        ))}
    </div>
);

// Form shimmer - for detail/form pages
export const FormShimmer = ({ fields = 6 }) => (
    <div className="shimmer-form">
        {Array.from({ length: fields }).map((_, i) => (
            <div key={`field-${i}`} className="shimmer-form-field">
                <ShimmerBlock width="30%" height="14px" className="shimmer-form-label" />
                <ShimmerBlock width="100%" height="38px" className="shimmer-form-input" />
            </div>
        ))}
        <div className="shimmer-form-actions">
            <ShimmerBlock width="100px" height="36px" />
            <ShimmerBlock width="100px" height="36px" style={{ marginLeft: '12px' }} />
        </div>
    </div>
);

// List shimmer - for simple list views
export const ListShimmer = ({ items = 5 }) => (
    <div className="shimmer-list">
        {Array.from({ length: items }).map((_, i) => (
            <div key={`item-${i}`} className="shimmer-list-item">
                <ShimmerBlock width="40px" height="40px" className="shimmer-list-avatar" />
                <div className="shimmer-list-content">
                    <ShimmerBlock width="200px" height="16px" />
                    <ShimmerBlock width="150px" height="14px" style={{ marginTop: '6px' }} />
                </div>
            </div>
        ))}
    </div>
);

// Hero shimmer - for page headers
export const HeroShimmer = () => (
    <div className="shimmer-hero mb-4">
        <div className="shimmer-hero-card">
            <div className="d-flex align-items-center">
                <ShimmerBlock width="32px" height="32px" className="rounded me-3" />
                <div className="d-flex flex-column">
                    <ShimmerBlock width="200px" height="24px" className="mb-2" />
                    <ShimmerBlock width="300px" height="16px" />
                </div>
            </div>
        </div>
    </div>
);

const Shimmer = {
    ShimmerBlock,
    TableShimmer,
    CardShimmer,
    StatsShimmer,
    FormShimmer,
    ListShimmer,
    HeroShimmer
};

export default Shimmer;
